<template>
  <div class="g-page">
    <div class="content-container">

      <!-- HEADER QISMI: Faqat bitta va professional -->
      <div class="header-row mb-4">
        <div class="d-flex align-items-center">
          <button class="back-circle-btn mr-3" @click="$router.go(-1)" type="button">
            <b-icon icon="chevron-left"></b-icon>
          </button>
          <h2 class="page-title">
            {{ $route.params.id ? $t('Mijozni tahrirlash') : $t('Yangi Mijoz Qo\'shish') }}
          </h2>
        </div>
        <div class="header-actions">
          <button class="btn-cancel mr-2" @click="$router.go(-1)" type="button">
            {{ $t("Bekor qilish") }}
          </button>
          <button class="btn-save" @click="Savedokument" :disabled="loading" type="button">
            <b-spinner small v-if="loading" class="mr-1"></b-spinner>
            <b-icon icon="check-all" v-else class="mr-1"></b-icon>
            {{ $t("Saqlash") }}
          </button>
        </div>
      </div>

      <!-- ASOSIY FORMA KARTASI -->
      <div class="modern-card">
        <div class="row custom-gutter">

          <!-- Chap tomon: Umumiy ma'lumotlar -->
          <div class="col-md-6 section-divider">
            <div class="section-header">
              <b-icon icon="person-lines-fill"></b-icon>
              <span>{{ $t("Umumiy ma'lumotlar") }}</span>
            </div>

            <div class="form-unit">
              <label>{{ $t("F.I.O / Tashkilot nomi") }}</label>
              <input v-model="datas.name" type="text" :placeholder="$t('Kiriting...')" ref="focused">
            </div>

            <div class="row">
              <div class="col-6">
                <div class="form-unit">
                  <label>{{ $t("Telefon") }}</label>
                  <input v-model="datas.phone_number" type="text" placeholder="+998">
                </div>
              </div>
              <div class="col-6">
                <div class="form-unit">
                  <label>{{ $t("Manzil") }}</label>
                  <input v-model="datas.address" type="text" :placeholder="$t('Shahar, ko\'cha...')">
                </div>
              </div>
            </div>

            <div class="form-unit">
              <label>{{ $t("Izoh") }}</label>
              <textarea v-model="datas.comment" rows="4" :placeholder="$t('Qo\'shimcha ma\'lumotlar...')"></textarea>
            </div>
          </div>

          <!-- O'ng tomon: Moliyaviy va guruhlash -->
          <div class="col-md-6 pl-md-4">
            <div class="section-header">
              <b-icon icon="wallet2"></b-icon>
              <span>{{ $t("Moliyaviy ma'lumotlar") }}</span>
            </div>

            <div class="form-unit">
              <label>{{ $t("Mijoz turi") }} <span class="required-star">*</span></label>
              <div class="client-type-toggle">
                <button
                  type="button"
                  :class="['client-type-btn', { active: Number(datas.type) === 1 }]"
                  @click="datas.type = 1"
                >
                  <b-icon icon="person-fill" class="mr-1"></b-icon>
                  {{ $t("Oddiy mijoz") }}
                </button>
                <button
                  type="button"
                  :class="['client-type-btn', { active: Number(datas.type) === 2 }]"
                  @click="datas.type = 2"
                >
                  <b-icon icon="tools" class="mr-1"></b-icon>
                  {{ $t("Usta mijoz") }}
                </button>
                <button
                  type="button"
                  :class="['client-type-btn', { active: Number(datas.type) === 3 }]"
                  @click="datas.type = 3"
                >
                  <b-icon icon="gear-fill" class="mr-1"></b-icon>
                  {{ $t("Zapchas mijoz") }}
                </button>
              </div>
            </div>

            <div class="form-unit">
              <label>{{ $t("Sotuv turi") }}</label>
              <div class="sale-type-toggle">
                <button
                  type="button"
                  :class="['sale-type-btn', { active: datas.sale_type === 'chakana' }]"
                  @click="datas.sale_type = 'chakana'"
                >
                  {{ $t("Chakana") }}
                </button>
                <button
                  type="button"
                  :class="['sale-type-btn', { active: datas.sale_type === 'optom' }]"
                  @click="datas.sale_type = 'optom'"
                >
                  {{ $t("Optom") }}
                </button>
              </div>
            </div>

            <div class="row">
              <div class="col-6">
                <div class="form-unit">
                  <label>{{ $t("INN") }}</label>
                  <input v-model="datas.inn" type="text" placeholder="000 000 000">
                </div>
              </div>
              <div class="col-6">
                <div class="form-unit">
                  <label>{{ $t("MFO") }}</label>
                  <input v-model="datas.mfo_id" type="text" placeholder="00000">
                </div>
              </div>
            </div>

            <!-- <div class="form-unit">
              <label>{{ $t("Guruh (Papka)") }}</label>
              <v-select :options="folder" v-model="datas.parent_id" :reduce="n => n.id" label="name"
                class="modern-vselect" :placeholder="$t('Guruhni tanlang')"></v-select>
            </div> -->

            <!-- <div class="folder-switch-box mt-4">
              <div class="custom-control custom-switch modern-switch">
                <input type="checkbox" class="custom-control-input" id="isFolder" v-model="datas.is_folder">
                <label class="custom-control-label" for="isFolder">
                  {{ $t("Ushbu mijozni guruh (papka) sifatida saqlash") }}
                </label>
              </div>
            </div> -->
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  // Parent componentdan keladigan ma'lumotlar
  props: {
    datas: {
      type: Object,
      default: () => ({
        name: '',
        phone_number: '',
        address: '',
        comment: '',
        inn: '',
        mfo_id: 0,
        parent_id: null,
        is_folder: false,
        type: 1,
        sale_type: 'chakana',
        password:'123456'
      })
    }
  },
  data() {
    return {
      loading: false,
      folder: [],
      rule: { change: true }
    };
  },
  created() {
    // "Saqlanmagan ma'lumotlar" modalidagi "Ha" tugmasi shu instanceni chaqiradi
    this.$root.$refs.kontragent = this;
    this.loadFolders();
  },
  mounted() {
    // Sahifa ochilganda birinchi inputga fokus berish
    if (this.$refs.focused) {
      this.$refs.focused.focus();
    }
  },
  methods: {
    // Papkalar ro'yxatini yuklash
    loadFolders() {
      axios.get("api/v1/kontragent/folder-list")
        .then(res => {
          this.folder = res.data;
        })
        .catch(err => console.error("Guruhlarni yuklashda xato:", err));
    },

    // Ma'lumotni saqlash
    async Savedokument() {
      if (this.rule.change === false) {
        alert(this.$t("Sizda ruxsat yo'q"));
        return;
      }

      this.loading = true;
      const id = this.$route.params.id;
      const method = id ? "patch" : "post";
      const url = id ? `api/v1/kontragent/id/${id}` : "api/v1/kontragent/";

      try {
        await axios({ method, url, data: this.datas });
        this.$store.state.saved = 1; // Muvaffaqiyatli saqlash flagi
        this.$router.push({ path: "/malumot/kontragent/index" });
      } catch (err) {
        console.error("Saqlashda xatolik:", err);
        alert(this.$t("Xatolik yuz berdi"));
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
/* SAHIFA ASOSI */
.g-page {
  padding: 30px;
  background: #f4f7f9;
  min-height: 100vh;
}

.content-container {
  max-width: 1100px;
  margin: 0 auto;
}

/* HEADER STYLE */
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.page-title {
  font-weight: 800;
  font-size: 24px;
  color: #2c3e50;
  margin: 0;
}

.back-circle-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #e0e6ed;
  background: white;
  color: #7f8c8d;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.3s;
  cursor: pointer;
}

.back-circle-btn:hover {
  background: #a142f4;
  color: white;
  border-color: #a142f4;
}

/* TUGMALAR */
.btn-save {
  background: #a142f4;
  color: white;
  border: none;
  padding: 10px 25px;
  border-radius: 10px;
  font-weight: 700;
  box-shadow: 0 4px 12px rgba(161, 66, 244, 0.25);
  transition: 0.3s;
  cursor: pointer;
}

.btn-save:hover:not(:disabled) {
  background: #8e39d9;
  transform: translateY(-1px);
}

.btn-save:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.btn-cancel {
  background: white;
  border: 1px solid #dcdde1;
  color: #7f8c8d;
  padding: 10px 20px;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
}

/* MODERN CARD */
.modern-card {
  background: white;
  border-radius: 24px;
  padding: 40px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.02);
  border: 1px solid #f1f2f6;
}

.section-divider {
  border-right: 1px solid #f1f2f6;
  padding-right: 30px;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 25px;
  color: #2c3e50;
  font-weight: 700;
  font-size: 16px;
}

.section-header svg {
  color: #a142f4;
}

/* FORM UNITS */
.form-unit {
  margin-bottom: 20px;
}

.form-unit label {
  display: block;
  font-size: 12px;
  font-weight: 700;
  color: #95a5a6;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.form-unit input,
.form-unit textarea {
  width: 100%;
  background: #f8fafc;
  border: 1px solid #f8fafc;
  border-radius: 12px;
  padding: 12px 15px;
  color: #2c3e50;
  font-weight: 600;
  transition: 0.3s;
}

.form-unit input:focus,
.form-unit textarea:focus {
  background: white;
  border-color: #a142f4;
  outline: none;
  box-shadow: 0 0 0 4px rgba(161, 66, 244, 0.05);
}

/* SWITCH */
.folder-switch-box {
  background: #f8fafc;
  padding: 15px;
  border-radius: 12px;
  border: 1px solid #f1f5f9;
}

.modern-switch .custom-control-label {
  font-weight: 600;
  color: #4b5563;
  padding-top: 2px;
  cursor: pointer;
}

.modern-switch .custom-control-input:checked~.custom-control-label::before {
  background-color: #a142f4;
  border-color: #a142f4;
}

/* V-SELECT MOSLASH */
::v-deep .modern-vselect .vs__dropdown-toggle {
  background: #f8fafc;
  border: 1px solid #f8fafc;
  border-radius: 12px;
  padding: 6px;
}

::v-deep .modern-vselect.vs--open .vs__dropdown-toggle {
  background: white;
  border-color: #a142f4;
}

/* SALE TYPE TOGGLE */
.sale-type-toggle {
  display: flex;
  gap: 10px;
}

.sale-type-btn {
  flex: 1;
  padding: 10px 20px;
  border-radius: 12px;
  border: 1px solid #e0e6ed;
  background: #f8fafc;
  color: #7f8c8d;
  font-weight: 700;
  cursor: pointer;
  transition: 0.3s;
}

.sale-type-btn.active {
  background: #a142f4;
  color: white;
  border-color: #a142f4;
  box-shadow: 0 4px 12px rgba(161, 66, 244, 0.25);
}

.sale-type-btn:hover:not(.active) {
  border-color: #a142f4;
  color: #a142f4;
}

/* MIJOZ TURI TOGGLE */
.client-type-toggle {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.client-type-btn {
  flex: 1;
  min-width: 110px;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid #e0e6ed;
  background: #f8fafc;
  color: #7f8c8d;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  transition: 0.25s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.client-type-btn.active {
  background: linear-gradient(135deg, #a142f4 0%, #8b2cf5 100%);
  color: white;
  border-color: #a142f4;
  box-shadow: 0 4px 12px rgba(161, 66, 244, 0.25);
}

.client-type-btn:hover:not(.active) {
  border-color: #a142f4;
  color: #a142f4;
}

.required-star {
  color: #e11d48;
  font-weight: 800;
  margin-left: 2px;
}

@media (max-width: 768px) {
  .section-divider {
    border-right: none;
    border-bottom: 1px solid #f1f2f6;
    padding-right: 0;
    margin-bottom: 30px;
    padding-bottom: 30px;
  }
}
</style>